import { styled } from '@linaria/react';

import { colors, layout, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  border: 1px solid ${semantic.border.default};
  border-radius: ${layout.borderRadiusLg};
  background: ${colors.white};
  padding: ${space[5]};
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const DiscountStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;
